export const ENABLE_GLOBAL_TECHNICIAN_PROFILE = false;

export function getTechnicianLandingPath({
  hasSelectedSalon,
  selectedSalonId,
  staffSetupComplete,
  profileComplete,
}) {
  const salonSelected = hasSelectedSalon || Boolean(selectedSalonId);
  if (!salonSelected) {
    return "/find-salons";
  }

  const staffComplete = Boolean(staffSetupComplete);
  const profileDone = Boolean(profileComplete);

  if (!staffComplete) {
    return "/technician/setup";
  }

  if (!profileDone && ENABLE_GLOBAL_TECHNICIAN_PROFILE) {
    return "/technician/profile";
  }

  return "/technician/schedule";
}
